module.exports = __webpack_public_path__ + "img/1970East-081_WEB-min.59a3dedb.jpg";